import { createFileRoute } from "@tanstack/react-router";
import Reviews from "@/pages/site/Reviews";

export const Route = createFileRoute("/reviews")({
  component: () => <Reviews />,
});
